/*  eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './ManageCookies.scss';

const ManageCookies = () => (
  <div className="manage-cookies">
    <a target="_blank" rel="noopener noreferrer" href="https://www.butlins.com/privacy-and-cookies">Privacy & Cookies</a>
    <a className="ot-sdk-show-settings" href="#">Manage Cookies</a>
  </div>
);

export default ManageCookies;
